import axios from 'axios';

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
  },
  // timeout: 20000,
});

export default instance;
